import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createProduct, updateProduct, deleteProduct } from './request';
import { PRODUCTS_QUERY_KEY } from '@/api/queries/product/key';
import toast from 'react-hot-toast';

export const useCreateProduct = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createProduct,
    onSuccess: ({ response }) => {
      toast.success(response);
      queryClient.invalidateQueries({ queryKey: [PRODUCTS_QUERY_KEY] });
      onSuccess?.();
    },
  });
};

export const useUpdateProduct = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateProduct,
    onSuccess: ({ response }) => {
      toast.success(response);
      queryClient.invalidateQueries({ queryKey: [PRODUCTS_QUERY_KEY] });
      onSuccess?.();
    },
  });
};

export const useDeleteProduct = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteProduct,
    onSuccess: ({ response }) => {
      toast.success(response);
      queryClient.invalidateQueries({ queryKey: [PRODUCTS_QUERY_KEY] });
      onSuccess?.();
    },
  });
};
